(function ($) {
	$('.js-show-more-btn').on('click', function () {
		$(this).siblings('.js-show-more').toggleClass("open");
		$(this).children('.js-toggle-btn').toggleClass("open");
	});
})(jQuery);
